import React from 'react';
import { classNames } from '../../utils/classNames';

export const Textarea = ({ label, className, ...props }) => (
  <label className="block space-y-2">
    {label ? <span className="text-sm font-medium text-muted">{label}</span> : null}
    <textarea
      className={classNames(
        'min-h-[120px] w-full rounded-2xl border border-border bg-white/80 px-4 py-3 text-sm text-text outline-none placeholder:text-muted/80 focus:border-accent dark:bg-slate-950/40',
        className
      )}
      {...props}
    />
  </label>
);
